<template>
    <div style="background: #fff;height:100%">
        <Headers :title="title" />
        <div class="title-wrap">
            <div class="title-wrap-left">
                <img :src="imgurl" alt="">
            </div>
            <div class="title-wrap-right">
                <span class="product-name">{{name}}</span>
                <div v-if="this.is_store == '0'" class="store" @click.stop="handleCollect()">
                    <img class="store-icon" src="~statics/mobileShouye/unstore.png" alt="">
                    <span class="store-name">{{$t('detail').collect}}</span>
                </div>
                <div v-else class="store" @click.stop="handleCollect()">
                    <img class="store-icon"  src="~statics/mobileShouye/store.png" alt="">
                    <span class="store-name">{{$t('detail').uncollect}}</span>
                </div>
            </div>
            <div class="company-name">
                <span>{{language == 'zh'? gsName : en_gsName}}</span>
            </div>
        </div>
        <div class="info-wrap">
            <div class="info-title">
                <div class="line"></div>
                <div class="title-name">
                    {{$t('detail').introduction}}
                </div>
            </div>
            <div class="info">
                <div class="info-content">
                    <span class="info-content-title">{{$t('detail').msg1}}:</span>
                    <span class="info-content-desc">{{ price_low }}~{{ price_high }}</span>
                </div>
                <div class="info-content">
                    <span class="info-content-title">{{$t('detail').msg2}}:</span>
                    <span class="info-content-desc">{{ brand || '暂无' }}</span>
                </div>
                <div class="info-content">
                    <span class="info-content-title">{{$t('detail').msg3}}:</span>
                    <span class="info-content-desc">{{ model || '暂无'}}</span>
                </div>
                <div class="info-content">
                    <span class="info-content-title">{{$t('detail').msg4}}:</span>
                    <span class="info-content-desc">{{ specification || '暂无'}}</span>
                </div>
                <div class="info-content">
                    <span class="info-content-title">{{$t('detail').msg5}}:</span>
                    <span class="info-content-desc">{{ technical_parameter || '暂无'}}</span>
                </div>
            </div>
        </div>
        <div class="info-wrap-desc">
            <div class="info-title">
                <div class="line"></div>
                <div class="title-name">
                    {{$t('detail').introduction}}
                </div>
            </div>
            <div class="info">
                <div class="info-desc">{{info}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers";
import Footers from "../mobileExhibition/components/Footers";
import { mapState } from "vuex";
import api from "@/api";

export default {
    
    data(){
        return{
            exhibition_id: '',
            company_id: '',
            instance_id: '',
            title: "展台", 
            company_id: null,
            exhibition_id: null,
            exhibition_product_id: null,
            is_store: '',
            id: null,
            company_id: null,
            exhibition_id: null,
            name: "", //产品名称
            info: "", //简介
            gsName: "", //公司名称
            en_gsName: "",
            price_high: "", //最高价格
            price_low: "", //最低价格
            model: "", //品牌型号
            technical_parameter: "", //技术参数
            specification: "", //产品规格
            brand: "" ,//品牌名称
            imgurl: "" //产品图片
        }
    },
    computed: {
        ...mapState(["userInfo","language"]),
    },
    created() {
        this.exhibition_id = this.$route.query.exhibition_id;
        this.company_id = this.$route.query.company_id
        this.exhibition_product_id = this.$route.query.exhibition_product_id
        this.getProductDetail();
    },
    mounted(){
        console.log(this.userInfo)
    },
    methods: {
        getProductDetail() {
            api.getProductDetail({
                id: this.exhibition_product_id,
                params: {
                    exhibition_id: this.exhibition_id,
                    company_id: this.company_id
                }
            }).then((res) => {
                if (res.res == 1) {
                    this.id = res.info.id;
                    this.is_store = res.info.is_store;
                    this.name = res.info.product.cn.name;
                    this.info = res.info.product.cn.info;
                    this.imgurl = res.info.product.cn.sub_images[0].url;
                    this.gsName = res.info.company.name;
                    this.en_gsName = res.info.company.locales.en.name
                    this.price_low = res.info.product.price_low;
                    this.price_high = res.info.product.price_high;
                    this.model = res.info.product.model;
                    this.technical_parameter = res.info.product.cn.technical_parameter;
                    this.specification = res.info.product.cn.specification;
                    this.brand = res.info.product.cn.brand;
                }
            });
        },
        handleCollect(){
            if(!this.userInfo.id) {
                this.$notice({ type: 'danger', message: '请先登录后收藏' });
                return
            }else {
                if(this.is_store == 0){
                    this.collect()
                    return
                }else{
                    this.cancelCollect()
                    return
                }
            }
        },
        // 收藏
        collect() {
            api.isCollectProduct({
                exhibition_product_id: this.exhibition_product_id
            }).then((res) => {
                console.log(res);
                if (res.res == 1) {
                    this.is_store = 1;
                    this.$notify({ type: 'success', message: '收藏成功' });
                }
            });
        },
        // 取消收藏
        cancelCollect() {
            api.noCollectProduct({
                exhibition_product_id: this.exhibition_product_id
            }).then((res) => {
                console.log(res);
                if (res.res == 1) {
                    this.is_store = 0;
                    this.$notify("取消收藏");
                }
            });
        },
    },
    components: {
        Footers,
        Headers
    },
    
}
</script>

<style lang="scss" scoped>
/deep/ .van-notice-bar__content{
    line-height: .32rem;
    color: #ffffff;
    opacity: 1;
    font-size: 12px
}
/deep/ .van-notice-bar__left-icon{
    color: #fff;
}
/deep/ .van-notice-bar__right-icon{
    color: #fff;
}
/deep/ .van-nav-bar__title{
    color: #fff;
}
/deep/ .van-hairline--bottom{
    background: #194b96;
}
/deep/ .van-icon-search{
    color: #fff;
}
.title-wrap{
    width: 6.9rem;
    height: 5.9rem;
    border-bottom: 1px solid #f1f1f8;
    margin: .30rem 0 0 .3rem;
    display: flex;
    flex-direction: column;
    padding-bottom: .4rem;
    .title-wrap-left{
        width: 6.9rem;
        height: 4.3rem;
        margin-right: .22rem;
        img{
            border: 1px solid #e1e1ed;
            width: 100%;
            height: 100%;
            border-radius: 7px;
        }
    }
    .title-wrap-right{
        display: flex;
        justify-content: space-between;
        margin: .3rem 0 .12rem 0;
        .product-name{
            width: 4rem;
            font-size: 16px;
            color: #333333;
            line-height: .42rem;
            overflow: hidden; 
            white-space: nowrap; 
            text-overflow: ellipsis;
        }
        .store{
            display: flex;
            justify-content: center;
            align-items: center;
            .store-icon{
                width: .24rem;
                height: .24rem;
                margin-right: .1rem;
                line-height: .3rem;
            }
            .store-name{
                line-height: .3rem;
                color: #999;
                font-size: 12px;
            }
        }
    }
    .company-name{
        font-size: 12px;
        line-height: .3rem;
        color: #999;
    }
}
.info-wrap{
    width: 6.9rem;
    // height: 4.22rem;
    border-bottom: 1px solid #f1f1f8;
    // background: red;
    margin: .4rem 0 0 .3rem;
    padding-bottom: .4rem;
    .info-title{
        display: flex;
        .line{
            width: .06rem;
            height: .36rem;
            background: #194b96;
            margin-right: .12rem;
        }
        .title-name{
            color: #333333;
            line-height: .42rem;
            font-size: 16px;
        }
    }
    .info{
        margin-top: .2rem;
        width: 6.9rem;
        .info-content{
            margin-bottom: .1rem;
            width: 6.9rem;
            display: flex;
            justify-content: center;
            .info-content-title{
                width: 2.2rem;
                margin-right: .3rem;
                font-size: 14px;
                color: #666666;
                line-height: .46rem;
            }
            .info-content-desc{
                width: 4.64rem;
                line-height: .46rem;
                color: #333;
                font-size: 14px;
            }
        }
        
    }
}
.info-wrap-desc{
    width: 6.9rem;
    // height: 4.22rem;
    border-bottom: 1px solid #f1f1f8;
    // background: red;
    margin: .4rem 0 0 .3rem;
    padding-bottom: .4rem;
    .info-title{
        display: flex;
        .line{
            width: .06rem;
            height: .36rem;
            background: #194b96;
            margin-right: .12rem;
        }
        .title-name{
            color: #333333;
            line-height: .42rem;
            font-size: 16px;
        }
    }
    .info{
        .info-desc{
            margin-top: .2rem;
            font-size: 14px;
            color: #666666;
            line-height: .46rem;
        }
    }
    
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileAboutProductDetail/index.vue